export default "__VITE_ASSET__f2df084c__"